
import PersonIcon from '@/shared/ui/Icons/Person.vue';
import HeartIcon from '@/shared/ui/Icons/Heart.vue';
import CartIcon from '@/shared/ui/Icons/Cart.vue';
import HouseIcon from '@/shared/ui/Icons/House.vue';
import SquareIcon from '@/shared/ui/Icons/Squares.vue';

import { useUserStore } from '@/entities/user/index';
import { storeToRefs } from 'pinia';
import { useModalsStore } from '@/app/store/modals';

export const useNavMenu = (navType: string) => {
  const userStore = useUserStore();
  const { setModalState } = useModalsStore();
  const localePath = useLocalePath();
  const { t } = useI18n();
  const { isAuth } = storeToRefs(userStore);

  const profileText = computed(() => (isAuth.value ? t('profile') : t('enter')));

  const links = computed(() => navType === 'header' ? [
    {
      id: 1,
      name: profileText.value,
      icon: PersonIcon,
      href: localePath('profile'),
      requiresAuth: true,
    },
    {
      id: 2,
      name: t('favorites'),
      icon: HeartIcon,
      href: localePath('profile-favorites'),
      classMod: '_favorite',
      requiresAuth: true,
    },
    {
      id: 3,
      name: t('cart.cart'),
      icon: CartIcon,
      href: localePath('cart'),
      requiresAuth: true,
    },
  ] : [
    {
      id: 1,
      name: t('main'),
      icon: HouseIcon,
      href: localePath('/'),
      requiresAuth: false,
    },
    {
      id: 2,
      name: t('catalog'),
      icon: SquareIcon,
      href: localePath('catalog'),
      requiresAuth: false,
    },
    {
      id: 3,
      name: t('cart.cart'),
      icon: CartIcon,
      href: localePath('cart'),
      requiresAuth: true,
    },
    {
      id: 4,
      name: t('favorites'),
      icon: HeartIcon,
      href: localePath('profile-favorites'),
      requiresAuth: true,
    },
    {
      id: 5,
      name: profileText.value,
      icon: PersonIcon,
      href: localePath('profile'),
      requiresAuth: true,
    },
  ]);

  return {
    isAuth,
    links,
    profileText,
    t,
    setModalState,
  };
};
